import React from 'react';
import { ThemeProvider } from 'styled-components';
import { DeleteOutlined } from '@ant-design/icons';
import { useTheme } from '../../../context/ThemeContext';
import CustomInput from '../../../commonComponents/input';
import CustomSelector from '../../../commonComponents/Selector';
import { TemplateFiltersProps } from './types';
import { FILTER_STATUS_OPTIONS, FILTER_DEFAULT_OPTIONS, FILTER_LABELS } from './constants';
import * as S from './styled';

const TemplateFiltersWithTheme: React.FC<TemplateFiltersProps> = ({
  searchTerm,
  setSearchTerm,
  typeFilter,
  setTypeFilter,
  statusFilter,
  setStatusFilter,
  isDefaultFilter,
  setIsDefaultFilter,
  templateTypes,
  onClearFilters,
}) => {
  const { isDarkMode } = useTheme();

  const typeOptions = [
    {
      value: '',
      label: FILTER_LABELS.TYPE,
    },
    ...templateTypes.map((t) => ({
      value: t.type,
      label: t.label,
    })),
  ];

  return (
    <S.FilterContainer isDarkMode={isDarkMode}>
      <S.FilterContent>
        <S.DesktopLayout>
          <S.SearchInputWrapper>
            <CustomInput
              value={searchTerm}
              onChange={setSearchTerm}
              placeholder={FILTER_LABELS.SEARCH}
              allowClear
            />
          </S.SearchInputWrapper>

          <S.FilterSelectWrapper>
            <CustomSelector
              value={typeFilter}
              onChange={setTypeFilter}
              options={typeOptions}
              width={140}
            />
          </S.FilterSelectWrapper>

          <S.FilterSelectWrapper>
            <CustomSelector
              value={statusFilter}
              onChange={setStatusFilter}
              options={FILTER_STATUS_OPTIONS}
              width={140}
            />
          </S.FilterSelectWrapper>

          <S.FilterSelectWrapper>
            <CustomSelector
              value={isDefaultFilter}
              onChange={setIsDefaultFilter}
              options={FILTER_DEFAULT_OPTIONS}
              width={140}
            />
          </S.FilterSelectWrapper>

          <S.ClearButtonWrapper>
            <S.ClearButton isDarkMode={isDarkMode} onClick={onClearFilters}>
              <DeleteOutlined style={{ marginRight: '6px' }} />
              Clear
            </S.ClearButton>
          </S.ClearButtonWrapper>
        </S.DesktopLayout>

        <S.TabletLayout>
          <CustomInput
            value={searchTerm}
            onChange={setSearchTerm}
            placeholder={FILTER_LABELS.SEARCH}
            allowClear
          />

          <S.SelectsRow>
            <S.SelectGroup>
              <CustomSelector
                value={typeFilter}
                onChange={setTypeFilter}
                options={typeOptions}
                width="100%"
              />
            </S.SelectGroup>

            <S.SelectGroup>
              <CustomSelector
                value={statusFilter}
                onChange={setStatusFilter}
                options={FILTER_STATUS_OPTIONS}
                width="100%"
              />
            </S.SelectGroup>
          </S.SelectsRow>

          <S.SelectsRow>
            <S.SelectGroup>
              <CustomSelector
                value={isDefaultFilter}
                onChange={setIsDefaultFilter}
                options={FILTER_DEFAULT_OPTIONS}
                width="100%"
              />
            </S.SelectGroup>

            <S.ClearButtonWrapper>
              <S.ClearButton isDarkMode={isDarkMode} onClick={onClearFilters}>
                <DeleteOutlined style={{ marginRight: '6px' }} />
                Clear
              </S.ClearButton>
            </S.ClearButtonWrapper>
          </S.SelectsRow>
        </S.TabletLayout>

        {/* Mobile Layout */}
        <S.MobileLayout>
          <CustomInput
            value={searchTerm}
            onChange={setSearchTerm}
            placeholder={FILTER_LABELS.SEARCH}
            allowClear
          />

          <S.SelectsRow>
            <S.SelectGroup>
              <CustomSelector
                value={typeFilter}
                onChange={setTypeFilter}
                options={typeOptions}
                width="100%"
              />
            </S.SelectGroup>

            <S.SelectGroup>
              <CustomSelector
                value={statusFilter}
                onChange={setStatusFilter}
                options={FILTER_STATUS_OPTIONS}
                width="100%"
              />
            </S.SelectGroup>
          </S.SelectsRow>

          <S.SelectsRow>
            <S.SelectGroup>
              <CustomSelector
                value={isDefaultFilter}
                onChange={setIsDefaultFilter}
                options={FILTER_DEFAULT_OPTIONS}
                width="100%"
              />
            </S.SelectGroup>

            <S.ClearButtonWrapper>
              <S.ClearButton isDarkMode={isDarkMode} onClick={onClearFilters}>
                <DeleteOutlined style={{ marginRight: '6px' }} />
                Clear
              </S.ClearButton>
            </S.ClearButtonWrapper>
          </S.SelectsRow>
        </S.MobileLayout>
      </S.FilterContent>
    </S.FilterContainer>
  );
};

const TemplateFilters: React.FC<TemplateFiltersProps> = (props) => (
  <ThemeProvider theme={{ mode: props as any }}>
    <TemplateFiltersWithTheme {...props} />
  </ThemeProvider>
);

export default TemplateFilters;
export { TemplateFiltersWithTheme };
